import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import {
  TuiDataList,
  TuiError,
  TuiInput,
  TuiDropdown,
  TuiTextfield,
  TuiLabel,
  TuiCalendar,
} from '@taiga-ui/core';
import { TuiSelect, TuiInputDate, TuiChevron } from '@taiga-ui/kit';
import { TranslatePipe } from '@ngx-translate/core';
import type { Counterparty } from '@core/types';
import { OutkeepPermissionService } from '@core/services/permission';

@Component({
  selector: 'x-request-create-step-1a',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TuiTextfield,
    TuiLabel,
    TuiChevron,
    TuiCalendar,
    ReactiveFormsModule,
    AsyncPipe,
    TuiInput,
    TuiInputDate,
    TuiSelect,
    TuiDataList,
    TuiError,
    TranslatePipe,
    TuiDropdown,
  ],
  templateUrl: './step-1a-counterparty.component.html',
})
export class RequestCreateStep1aComponent {
  public readonly permissionService = inject(OutkeepPermissionService);
  readonly form = input.required<FormGroup>();
  readonly counterparties = input<Counterparty[]>([]);

  readonly stringifyCounterparty = (id: number): string => {
    const found = this.counterparties().find(c => c.id === id);

    return found?.name ?? '';
  };
}
